import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Plus } from "lucide-react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import VoiceTrackPanel from "@/components/production/VoiceTrackPanel";

const inputCls = "rounded-md border border-line bg-bg-elevated px-3 py-2 text-sm w-full";
const CATEGORIES = ["Intro", "Outro", "Music Link", "Promo", "Weather", "News", "Sponsor", "Transition", "Custom"];

export default function VoiceTrackStudio() {
  const [form, setForm] = useState({ title: "", show: "", category: "Music Link", script: "" });
  const [refreshKey, setRefreshKey] = useState(0);

  const create = async () => {
    try {
      await api.post("/production/voicetracks", form);
      toast.success("Voice track draft created — pending PD approval by default");
      setForm({ title: "", show: "", category: "Music Link", script: "" });
      setRefreshKey((k) => k + 1);
    } catch (e) { toast.error(e?.response?.data?.detail || "Create failed"); }
  };

  return (
    <div className="p-6 md:p-10 max-w-5xl mx-auto space-y-5" data-testid="voicetrack-studio-page">
      <Link to="/dashboard/production" className="inline-flex items-center gap-1 text-xs font-bold text-ink-muted hover:text-ink-primary" data-testid="vt-back-hub">
        <ArrowLeft className="h-3.5 w-3.5" /> Production Hub
      </Link>
      <PageHeader eyebrow="// PRODUCTION SUITE · VOICETRACK STUDIO" title="VoiceTrack Studio"
        description="Song-aware talk-over voice tracking — record or upload takes, drag markers, preview with live auto-ducking, and insert straight into your on-air log." />

      <VoiceTrackPanel key={refreshKey} docked={false} />

      <div className="rounded-xl border border-line bg-bg-surface p-4 space-y-3" data-testid="vt-create-form">
        <div className="text-sm font-bold flex items-center gap-2"><Plus className="h-4 w-4 text-brand-amber" /> New voice track draft</div>
        <div className="grid sm:grid-cols-3 gap-2">
          <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="Title (e.g. Anita Baker — Sweet Love link)" data-testid="vt-new-title" className={`${inputCls} sm:col-span-2`} maxLength={140} />
          <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
            data-testid="vt-new-category" className={inputCls}>
            {CATEGORIES.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <input value={form.show} onChange={(e) => setForm({ ...form, show: e.target.value })}
          placeholder="Show (optional)" data-testid="vt-new-show" className={inputCls} maxLength={100} />
        <textarea rows={3} value={form.script} onChange={(e) => setForm({ ...form, script: e.target.value })}
          placeholder="Script / talking points for this break (optional in Phase 1)" data-testid="vt-new-script"
          className={`${inputCls} font-mono`} maxLength={4000} />
        <button onClick={create} disabled={!form.title.trim()} data-testid="vt-create-btn"
          className="rounded-lg bg-brand-amber px-5 py-2 text-xs font-bold text-black disabled:opacity-50">
          Create draft
        </button>
      </div>
    </div>
  );
}
